import React from "react";
import { Control } from "react-hook-form";
import { UseFormSelect } from "./UseFormSelect";
import { SxProps } from "@mui/material";

interface UseFormSelectContactOrderStatusProps {
  control: Control
  name: string
  sx: SxProps
}

export const UseFormSelectContactOrderStatus: React.FC<UseFormSelectContactOrderStatusProps> = ({
  control,
  name,
  sx = {}
}) => {
  return (
    <UseFormSelect
      control={control}
      name={name}
      items={[
        {value: 'PENDING', label: 'PENDING'},
        {value: 'NEGOTIATION', label: 'NEGOTIATION'},
        {value: 'CANCEL', label: 'CANCEL'},
        {value: 'ACCEPTED', label: 'ACCEPTED'},
        {value: 'IN_PROGRESS', label: 'IN PROGRESS'},
        {value: 'CLOSED', label: 'CLOSED'},
      ]}
      sx={{
        width: '160px',
        ...sx,
      }}
    />
  )
}